module.exports = __webpack_public_path__ + "img/green_003.d05cfb52.png";